/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LineItemPickerService {
  selectedLineItems = new BehaviorSubject([]);
  onAddItemClicked = new Subject();

  constructor() {
    //Line item picker component constructor
  }
}
